const isSmall = () =>
  typeof window !== 'undefined' ? window.matchMedia('(max-width: 450px)').matches : false
const isMedium = () =>
  typeof window !== 'undefined' ? window.matchMedia('(max-width: 768px)').matches : false
const isLarge = () =>
  typeof window !== 'undefined' ? window.matchMedia('(max-width: 1170px)').matches : false
const isHuge = () =>
  typeof window !== 'undefined' ? window.matchMedia('(max-width: 2000px)').matches : false
const isBigHuge = () =>
  typeof window !== 'undefined' ? window.matchMedia('(max-width: 5000px)').matches : false
const isGreatherThanMedium = () =>
  typeof window !== 'undefined' ? window.matchMedia('(min-width: 768px)').matches : false

const mediaQuery = { isSmall, isMedium, isLarge, isHuge, isBigHuge, isGreatherThanMedium }

module.exports = mediaQuery
